import React, { useState, useEffect } from "react";
import { Container, Row, Col, Stack } from "react-bootstrap";
import { Icon } from "semantic-ui-react";
import Store from "../../assets/showroom/store";
import { useMyGlobal } from '../../component/GlobalData';

const AboutUs = () => {
    const [language, setLanguage] = useState("id");

    const toggleLanguage = () => {
        setLanguage((prev) => (prev === "id" ? "en" : "id"));
    };

    const mission = [
        {
            title: language === "id" ? "Kualitas Terbaik" : "Premium Quality",
            desc: language === "id"
                ? "Menyediakan sepatu, apparel, dan perlengkapan basket terbaik dan paling autentik dari brand global terkemuka."
                : "To provide the finest and most authentic basketball footwear, apparel, and equipment from the world’s leading brands.",
            icon: "star"
        },
        {
            title: language === "id" ? "Pengalaman Retail" : "Retail Experience",
            desc: language === "id"
                ? "Menghadirkan konsep retail premium dan immersive melalui toko fisik dan platform online."
                : "To deliver a premium and immersive retail experience across our stores and online platforms.",
            icon: "shopping bag"
        },
        {
            title: language === "id" ? "Komunitas & Pertumbuhan" : "Community Growth",
            desc: language === "id"
                ? "Membangun fondasi grassroots yang kuat dengan mendukung komunitas lokal, pemain, dan pertumbuhan basket di semua level."
                : "To build a strong grassroots foundation by supporting local communities, players, and the growth of basketball at every level.",
            icon: "users"
        },
        {
            title: language === "id" ? "Ruang Koneksi" : "Connectivity Space",
            desc: language === "id"
                ? "Menciptakan ruang di mana pecinta basket merasa terhubung, terinspirasi, dan memiliki rasa memiliki (sense of belonging)."
                : "To create a space where basketball enthusiasts feel connected, inspired, and a true sense of belonging.",
            icon: "connectdevelop"
        },
        {
            title: language === "id" ? "Inovasi Berkelanjutan" : "Continuous Innovation",
            desc: language === "id"
                ? "Terus berinovasi dan memperluas jaringan kami dengan standar tertinggi dalam kualitas, integritas, dan layanan."
                : "To continuously innovate and expand our presence while upholding the highest standards of quality, integrity, and service excellence.",
            icon: "lightbulb"
        }
    ]


    const priorityCities = ["Bandung", "Jakarta", "Tangerang", "Karawang"];

    const stores = Store(language);
    const sortedStores = [...stores].sort((a, b) => {
        const aPriority = priorityCities.indexOf(a.city);
        const bPriority = priorityCities.indexOf(b.city);
        if (aPriority !== -1 && bPriority !== -1) {
            return aPriority - bPriority;
        }
        if (aPriority !== -1) return -1;
        if (bPriority !== -1) return 1;
        return a.city.localeCompare(b.city);
    });

    useEffect(() => {
        window.scrollTo(0, 0)
    })
    
    const { isPortrait, windowWidth } = useMyGlobal()

    return (
        <Container 
            className="pb-5" fluid='sm' 
            style={{ 
                minHeight: '90vh', 
                height: '100%', 
                marginTop: windowWidth < 1000 ? "12vh" : "18vh"
            }}
        >
            <h1 className="d-none">
                HOOPS Indonesia About Us - Destinasi Basket Terbesar di Indonesia
            </h1>
            <div className="d-flex justify-content-end align-items-center mb-4">
                <span className={`me-2 ${language === "id" ? "fw-bold" : ""}`}>ID</span>
                <div onClick={toggleLanguage} style={styles.toggle}>
                    <div
                        style={{
                            ...styles.toggleCircle,
                            transform:
                                language === "en"
                                    ? "translateX(28px)"
                                    : "translateX(0px)"
                        }}
                    />
                </div>
                <span className={`ms-2 ${language === "en" ? "fw-bold" : ""}`}>EN</span>
            </div>
            <section className="mb-5">
                <h2 className="display-4 mb-4">
                    <span style={{ color: "#F2711C" }}>
                        {language === "id" ? "Tentang" : "About"}
                    </span>{" "}
                    {/* <span style={{ color: "#767676" }}> */}
                    {language === "id" ? "Kami" : "Us"}
                    {/* </span> */}
                </h2>
                <p className="fs-5 fw-light mb-4 pb-5" style={{ textAlign: "justify" }}>
                    {language === "id"
                        ? `Didirikan pada tahun 2011, Hoops Indonesia pertama kali hadir di Galaxy Mall, Surabaya, Jawa Timur. Hoops Indonesia lahir dengan visi yang jelas: menjadi destinasi utama basket di Indonesia. Sebagai konsep retail spesialis basket multi-brand di bawah PT Java Footwear Sportindo, perusahaan sepatu dan apparel olahraga terkemuka yang berbasis di Bandung, Hoops Indonesia merupakan wujud komitmen penuh terhadap olahraga basket dan komunitas yang ada di dalamnya Hoops Indonesia hadir dari kesadaran bahwa Indonesia membutuhkan sebuah wadah yang lebih dari sekadar lapangan—sebuah tempat di mana para pecinta basket bisa terhubung, berekspresi, dan memperlihatkan passion mereka. Kami ingin menciptakan destinasi yang membawa semangat basket dari lapangan ke gaya hidup sehari-hari, serta menjadi rumah bagi siapa pun yang berbagi kecintaan terhadap permainan basket. Melalui visi tersebut, Hoops Indonesia menjadi pionir toko spesialis basket resmi pertama di Indonesia. Saat ini, Hoops Indonesia telah berkembang menjadi toko spesialis basket pertama dan terbesar di Indonesia, dengan 22 toko di 11 kota yang tersebar di seluruh wilayah Indonesia. Seiring ekspansi yang terus berlanjut, kami tetap berkomitmen menghadirkan pengalaman retail premium dengan standar autentisitas dan kualitas tanpa kompromi. Melalui jaringan toko fisik dan platform online, kami tidak hanya menjual produk, tetapi juga membangun fondasi grassroots yang kuat serta menumbuhkan budaya basket di Indonesia.`
                        : `Established in 2011, Hoops Indonesia first opened its doors at Galaxy Mall, Surabaya, East Java. Hoops Indonesia was founded with a clear vision to become Indonesia’s premier destination for basketball. As a multi brand basketball specialty retail concept under PT. Java Footwear Sportindo, a leading sports footwear and apparel company based in Bandung, Indonesia, Hoops Indonesia represents a dedicated commitment to the game and its culture. Born from the realization that Indonesia lacked a true space where basketball enthusiasts could connect and celebrate their passion beyond the boundaries of the court, Hoops Indonesia was created to be more than a store. We envisioned a destination that brings the spirit of basketball from the court to the streets, and a place where everyone who shares the same passion feels a sense of belonging. Through this vision, Hoops Indonesia became the pioneer of official basketball specialty stores in Indonesia. Today, Hoops Indonesia stands as the first and largest basketball specialty store in Indonesia, operating 22 stores across 11 cities nationwide. As we continue to expand, we remain committed to delivering a refined retail experience and upholding uncompromising standards of authenticity and quality. Through our retail stores and online platforms, we strive to deliver more than products and focus on building a strong grassroots foundation while nurturing basketball culture in Indonesia.`}
                </p>
                <h3 className="fs-3 custom-title text-center fw-bold">
                    {language === "id" ? "Dukungan Brand Global" : "Global Brand Support"}
                </h3>
                <p className="fs-5 fw-light mb-4 pb-5" style={{ textAlign: "center" }}>
                    {language === "id"
                        ? "Kami menghadirkan koleksi sepatu performa, apparel, dan perlengkapan terbaik dari brand global terkemuka seperti Nike, Adidas, Puma, Under Armour, dan lainnya, memastikan inovasi dan kualitas dalam setiap produk yang kami tawarkan. Didorong oleh passion terhadap permainan dan didukung oleh komunitas basket yang terus berkembang, kami berkomitmen tidak hanya menyediakan produk terbaik, tetapi juga membentuk dan mengangkat masa depan budaya basket di Indonesia."
                        : "We curate the finest performance footwear, apparel, and equipment from the world’s leading brands including Nike, Adidas, Puma, Under armour and many more, ensuring innovation and excellence in every product we offer. Driven by our passion for the game and supported by a growing basketball community, we are dedicated not only to providing exceptional products, but also to elevating and shaping the future of basketball culture across Indonesia."}
                </p>
                <h3 className="fs-3 custom-title text-center fw-bold">{language === "id" ? "Visi Kami" : "Our Vision"}</h3>
                <p className="fs-5 fw-light mb-4 pb-5" style={{ textAlign: "center" }}>
                    {language === "id"
                        ? "Menjadi destinasi basket terdepan dan paling terpercaya di Indonesia, membentuk dan mengangkat budaya basket nasional, serta menginspirasi generasi atlet di dalam dan di luar lapangan."
                        : "To be Indonesia’s leading and most trusted basketball destination, shaping and elevating the nation’s basketball culture while inspiring generations of athletes both on and off the court."}
                </p>
                <section className="pt-5">
                    <h3 className="fs-3 custom-title text-center fw-bold">
                        {language === "id" ? "Misi Kami" : "Our Missions"}
                    </h3>
                    <Row className="mt-2 g-4">
                        {mission.map((item, index) => (
                            <Col md={6} lg={4} key={index}>
                                <div style={styles.missionCard}>
                                    <div style={styles.missionAccent} />
                                    <div style={styles.missionContent}>
                                        <Icon
                                            className="fs-4 fw-bold"
                                            name={item.icon}
                                            size="large"
                                            style={{ color: "#F2711C", marginBottom: "10px" }}
                                        />
                                        <h5 className="fs-4 fw-bold">{item.title}</h5>
                                        <p className="fs-5 fw-light" style={{ textAlign: "center" }}>{item.desc}</p>
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </section>
            </section>

            <section style={{ marginTop: "10rem", minHeight: "100vh" }}>
                <h3 className="fs-3 custom-title text-center fw-bold">
                    {language === "id" ? "Store Kami" : "Our Store"}
                </h3>
                <p className="fs-5 fw-light mb-4 pb-5" style={{ textAlign: "center" }}>
                    {language === "id" ? (
                        <>
                            Saat ini{" "}
                            <b className="fw-bold">
                                Hoops Indonesia mengoperasikan 22 toko yang tersebar di 11 kota di Indonesia
                            </b>
                            , menghadirkan sepatu basket dan produk lifestyle premium lebih dekat
                            dengan komunitas kami di seluruh negeri.
                        </>
                    ) : (
                        <>
                            <b className="fw-bold">
                                Hoops Indonesia currently operates 22 stores across 11 cities in Indonesia
                            </b>
                            , bringing premium basketball footwear and lifestyle products closer to our growing community nationwide.
                        </>
                    )}
                </p>

                <Container>
                    <Row className="justify-content-center">
                        {sortedStores.map((store, index) => (
                            <Col
                                key={index}
                                xs={12}
                                sm={12}
                                md={6}
                                lg={4}
                                xl={4}
                                className="mb-4"
                            >
                                <div className="contact-container-child shadow-sm">
                                    <iframe
                                        src={store.map}
                                        width="100%"
                                        height="250"
                                        loading="lazy"
                                        referrerPolicy="no-referrer-when-downgrade"
                                        className="contact-map-map-child mb-2"
                                        style={{
                                            borderRadius: "10px 10px 0 0",
                                            border: "none"
                                        }}
                                    />

                                    <div className="contact-info-child p-3">
                                        <h6 className="fw-bold mb-2">{store.name}</h6>
                                        <div style={{ color: "#fff" }}>
                                            📍 {store.address}
                                        </div>
                                        {/* <div style={{color: "#fff"}}>
                                            📞 {store.phone}
                                        </div> */}
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>
        </Container>
    );
};

const styles = {
    toggle: {
        width: "60px",
        height: "30px",
        background: "#F2711C",
        borderRadius: "30px",
        cursor: "pointer",
        padding: "3px",
        position: "relative",
        transition: "0.3s",
    },
    toggleCircle: {
        width: "24px",
        height: "24px",
        background: "#fff",
        borderRadius: "50%",
        transition: "0.3s ease",
    },
    numberCircle: {
        width: "45px",
        height: "45px",
        borderRadius: "50%",
        background: "#f39c12",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: "bold",
        marginRight: "15px",
        fontSize: "18px",
    },
    missionCard: {
        position: "relative",
        background: "#fff",
        padding: "25px",
        borderRadius: "8px",
        boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
        height: "100%",
        transition: "all 0.3s ease"
    },
    missionAccent: {
        position: "absolute",
        left: "0",
        top: "20px",
        bottom: "20px",
        width: "4px",
        background: "#F2711C",
        borderRadius: "4px"
    },
    missionContent: {
        paddingLeft: "15px"
    },
    titleUnderline: {
        width: "90px",
        height: "4px",
        backgroundColor: "#F2711C",
        borderRadius: "4px",
    },

    verticalWrapper: {
        maxWidth: "700px",
        margin: "0 auto",
        position: "relative",
    },

    storeCard: {
        display: "flex",
        alignItems: "flex-start",
        padding: "25px",
        marginBottom: "25px",
        borderRadius: "14px",
        background: "#ffffff",
        boxShadow: "0 6px 18px rgba(0,0,0,0.06)",
        transition: "all 0.3s ease",
    },

    badgeNumber: {
        minWidth: "55px",
        height: "55px",
        borderRadius: "50%",
        background: "#F2711C",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: "bold",
        fontSize: "18px",
    },

    titleUnderline: {
        width: "80px",
        height: "4px",
        backgroundColor: "#F2711C",
        borderRadius: "4px",
    },
};

export default AboutUs;
